import React from 'react'
import PropTypes from 'prop-types'
import { Slider, Grid, Typography } from '@mui/material'
import { useStyles } from './style'
import Filter from '../filter'

/**
 * Give the user a range of values to choose from
 */
const RangeSliderFilter = props => {
  const {
    name,
    label,
    range,
    value = [0, range.values[1]],
    onChange = () => {},
    onApply,
    disableApply,
    disabled
  } = props
  const classes = useStyles(props)

  const handleChange = (event, newValue) => {
    onChange({ name, value: newValue })
  }

  return (
    <Filter
      label={label}
      onApply={() => onApply({ name, value })}
      disableApply={disableApply}
      disabled={disabled}
      classes={{ popover: classes.popover }}
    >
      <Grid
        container
        justifyContent='center'
        direction='column'
        className={classes.container}
      >
        <Grid container item justifyContent='space-between' wrap='nowrap'>
          {range.labels.map((label, idx) => (
            <Grid key={label} item xs>
              <Typography variant='body2'>
                <b>{label}:</b>
                {` ${value[idx]} mins`}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Grid item className={classes.slider}>
          <Slider
            value={value.map(v => Number(v))}
            min={range?.values[0]}
            max={range?.values[1]}
            onChange={handleChange}
            valueLabelDisplay='off'
            getAriaLabel={(index) =>
              index === 0 ? 'Start time' : 'End time'}
            getAriaValueText={(val) => `${val} mins`}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

RangeSliderFilter.propTypes = {
  /**
   * Name of the filter
   */
  name: PropTypes.string.isRequired,
  /**
   * Contents of the filter button
   */
  label: PropTypes.string,
  /**
   * Labels and values for range min and max
   */
  range: PropTypes.object.isRequired,
  /**
   * Controlled value - current range selected
   */
  value: PropTypes.arrayOf(PropTypes.number),
  /**
   * What happens when the range is changed?
   */
  onChange: PropTypes.func,
  /**
   *  Displays an apply button. Will close the popover.
   */
  onApply: PropTypes.func
}

RangeSliderFilter.defaultProps = {
  label: '',
  onChange: undefined,
  onApply: undefined
}

export default RangeSliderFilter
